(function pickupStoreAvailability() {
  if (!window.jQuery) {
    setTimeout(pickupStoreAvailability, 100);
    return;
  }

  (function ($) {
    "use strict";

    class PickupStoreAvailability extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.buttons = $(this).find("button");
        this.popup = document.querySelector("#Pickup-Availability");
        this.init();
        this.initWatcher();
      }

      init() {
        $(this.buttons?.[0]).addClass("active");
        this.buttons.on("click", this.handleClick.bind(this));
      }

      handleClick({ target }) {
        const button = $(target).closest("button");
        this.buttons.removeClass("active");
        button.addClass("active");

        if (button.data("toggle") == "pickup-availability") {
          $("pickup-availability button")?.click();
        }
      }

      initWatcher() {
        let _ = new ClassWatcher(
          this.popup,
          "active",
          () => {},
          () => {
            $(this.buttons?.[0]).click();
          }
        );
      }
    }

    class ClassWatcher {
      constructor(
        targetNode,
        classToWatch,
        classAddedCallback,
        classRemovedCallback
      ) {
        this.targetNode = targetNode;
        this.classToWatch = classToWatch;
        this.classAddedCallback = classAddedCallback;
        this.classRemovedCallback = classRemovedCallback;
        this.observer = null;
        this.lastClassState = targetNode.classList.contains(this.classToWatch);

        this.init();
      }

      init() {
        this.observer = new MutationObserver(this.mutationCallback.bind(this));
        this.observe();
      }

      observe() {
        this.observer.observe(this.targetNode, { attributes: true });
      }

      disconnect() {
        this.observer.disconnect();
      }

      mutationCallback(mutationsList) {
        for (let mutation of mutationsList) {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "class"
          ) {
            let currentClassState = mutation.target.classList.contains(
              this.classToWatch
            );
            if (this.lastClassState !== currentClassState) {
              this.lastClassState = currentClassState;
              if (currentClassState) {
                this.classAddedCallback();
              } else {
                this.classRemovedCallback();
              }
            }
          }
        }
      }
    }

    if (customElements.get("pickup-store-availability") === undefined) {
      customElements.define(
        "pickup-store-availability",
        PickupStoreAvailability
      );
    }
  })(window.jQuery);
})();
